import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
    listOption: {
        marginBottom: 20
    },
    center: {
        textAlign: "center"
    },
    mainIconImage: {
        width: "90%"
    },
    mainIcon: {
        borderRadius: 150,
        height: 150,
        margin: "50px auto 10px auto",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: 150
    },
    secondaryIcon: {
        color: "#fff",
        borderRadius: 75,
        height: 75,
        margin: "50px auto 10px auto",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: 75
    },
    smallText: {
        fontSize: '.7em'
    },
    standOutText: {
        fontSize: "1.5rem",
        fontFamily: "Roboto, Helvetica, Arial, sans-serif",
        fontWeight: 400,
        lineHeight: 1.5,
        letterSpacing: "0em",
        '& a' :{
            backgroundColor: '#fff'
        }
    }
}));

export default useStyles;
